import { bool, func, object, string } from 'prop-types'
import { Button, kuiperClassNames, PlaintextDiff } from '@opallabs/kuiper'
import { getNestedProperty, htmlToText } from '@opallabs/lambda'
import { Tooltip } from '@opallabs/lapidary'
import { track } from '@opallabs/quanta'

import './styles.scss'

const getIsOpen = (open, disabled) => open && !disabled

const getToggleIconGlyph = (open) => (open ? 'chevron-lg-e' : 'chevron-lg-w')

const withToggleTracking = (fn, startingOpenValue) => (e) => {
  // Since this toggle click event is handled before the state change,
  // the value of `startingOpenValue` will be opposite from what the user is
  // doing. If they're opening the drawer, the prior open value will be `false`.
  // To adjust, we record the state the user is aiming for.
  const openValueRequested = !startingOpenValue
  track('Content: Toggle Longform Diff', {
    'Is Open': openValueRequested,
  })
  return fn(e)
}

const LongformDiffDrawer = ({
  disabled = false,
  onToggleOpen,
  open = false,
  priorVersion,
  theme = 'standard',
  version,
}) => {
  const onClick = withToggleTracking(onToggleOpen, open)
  return (
    <div
      className={kuiperClassNames('longform-diff-drawer', theme, {
        'is-disabled': disabled,
        'is-open': getIsOpen(open, disabled),
      })}
    >
      <div className={kuiperClassNames('longform-drawer-toggle-bar')}>
        <div className={kuiperClassNames('longform-drawer-toggle')}>
          <Tooltip
            disabled={open}
            theme="light"
            tooltip="View changes"
            type="description"
          >
            <Button
              onClick={onClick}
              icon={getToggleIconGlyph(open)}
              iconOptions={{
                width: 7,
                height: 12,
              }}
              type="invisible"
            />
          </Tooltip>
        </div>
      </div>
      <div className={kuiperClassNames('longform-diff-content')}>
        <PlaintextDiff
          theme="code-wrap"
          oldText={getNestedProperty(priorVersion, 'formattedContent')}
          newText={getNestedProperty(version, 'formattedContent')}
          transform={htmlToText}
        />
      </div>
    </div>
  )
}
LongformDiffDrawer.propTypes = {
  disabled: bool,
  onToggleOpen: func.isRequired,
  open: bool,
  priorVersion: object,
  theme: string,
  version: object,
}

export default LongformDiffDrawer
